var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.631,
    height: 20,
    viewBox: "0 0 23.631 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#d57575;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.375 -5.625)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.375,22.216a.8.8,0,0,0-.8.8,1.026,1.026,0,0,1-1.023,1.023H5.989a1.026,1.026,0,0,1-1.023-1.023V8.239A1.026,1.026,0,0,1,5.989,7.216H16.557A1.026,1.026,0,0,1,17.58,8.239a.8.8,0,1,0,1.591,0,2.614,2.614,0,0,0-2.614-2.614H5.989A2.614,2.614,0,0,0,3.375,8.239V23.011a2.614,2.614,0,0,0,2.614,2.614H16.557a2.614,2.614,0,0,0,2.614-2.614A.8.8,0,0,0,18.375,22.216Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.185,11.061a.79.79,0,0,0-.562-.233.777.777,0,0,0-.563.233.792.792,0,0,0,0,1.125l3.7,3.648H11.2a.8.8,0,0,0,0,1.591h14.58l-3.614,3.642a.8.8,0,0,0,0,1.125l.006.006a.822.822,0,0,0,.557.222.768.768,0,0,0,.563-.233L27.986,17.5a1.116,1.116,0,0,0,0-1.659Z",
    transform: "translate(-1.349 -0.999)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.3e3986178d569c452144ed0ba7673a51.svg";
export { ForwardRef as ReactComponent };